function initVideoSwiper() {
    const root = document.querySelector('.collection-video-slider.swiper');
    if (!root || root.dataset.swiperInit) return;
    if (typeof Swiper === 'undefined') {
        setTimeout(initVideoSwiper, 100);
        return;
    }

    const swiper = new Swiper(root, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        navigation: {
            nextEl: root.querySelector('.swiper-button-next'),
            prevEl: root.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
            767: {
                slidesPerView: 3,
                spaceBetween: 20,
                centeredSlides: true,
                grabCursor: false,
                simulateTouch: false,
            },
            1024: {
                slidesPerView: 5,
                spaceBetween: 20,
                centeredSlides: true,
                grabCursor: false,
                simulateTouch: false,
            }
        },
        a11y: true,
        on: {
            slideChange: (swiperInstance) => {
                setTimeout(() => autoplayVisibleVideo(swiperInstance), 100);

            }
        }
    });

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                autoplayVisibleVideo(swiper);
            } 
            // else {
            //     if (window.innerWidth < 768) {
            //         setTimeout(() => {
            //             stopAllVideos()
            //         },5000)
            //     }
            // }
        });
    }, {
        threshold: 0.5
    });

    observer.observe(root);
    root.dataset.swiperInit = "1";
}

function autoplayVisibleVideo(swiper) {
    const root = document.querySelector('.collection-video-slider.swiper');

    const rect = root.getBoundingClientRect();
    const isMostlyVisible = rect.top < window.innerHeight && rect.bottom > 0;
    if (!isMostlyVisible) return;

    const activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;

    const iframe = activeSlide.querySelector("iframe");
    if (!iframe) return;

    const baseSrc = iframe.dataset.originalSrc || iframe.src.split("?")[0];
    const autoplaySrc = `${baseSrc}?background=%23ffffff&autoplay=true&loop=true&mute=true&controls=false&tr=w-500`;

    // Do nothing if it's already autoplaying
    if (iframe.src === autoplaySrc) return;

    // Stop videos in all other slides
    swiper.slides.forEach((slide, index) => {
        if (index !== swiper.activeIndex) {
            const otherIframe = slide.querySelector("iframe");
            if (otherIframe && otherIframe.src.includes("autoplay=true")) {
                const original = otherIframe.dataset.originalSrc || otherIframe.src.split("?")[0];
                otherIframe.src = original;
            }
        }
    });

    // Set autoplay src for active iframe
    iframe.src = autoplaySrc;
    iframe.dataset.originalSrc = baseSrc;
}

function stopAllVideos() {
    const iframes = document.querySelectorAll(".product-video-card iframe");
    iframes.forEach(iframe => {
        if (iframe.dataset.originalSrc) {
            iframe.src = iframe.dataset.originalSrc;
        }
    });
}


document.addEventListener("DOMContentLoaded", function () {
    initVideoSwiper();

    const videoCards = document.querySelectorAll(".product-video-card iframe");
    let currentPlaying = null;

    // Popup setup
    const popup = document.getElementById("video-popup");
    const popupIframe = document.getElementById("popup-iframe");
    const btnClose = document.getElementById("video-close");
    const btnNext = document.getElementById("video-next");
    const btnPrev = document.getElementById("video-prev");
    let currentIndex = 0;

    const videoList = Array.from(videoCards).map(iframe => {
        const base = iframe.dataset.originalSrc || iframe.src?.split("?")[0];
        return base;
    });

    document.querySelectorAll(".product-video-wrapper").forEach((card, index) => {
        card.addEventListener("click", () => {
            if (currentPlaying) {
            currentPlaying.src = currentPlaying.dataset.originalSrc;
            currentPlaying = null;
            }
            currentIndex = index;
            openPopup();
        });
    });

    function buttonLinkChange() {
        const buttonContainer = popup.querySelector('.video-iframe-button');
        buttonContainer.innerHTML = "";

        const clickedCard = document.querySelectorAll(".product-video-card")[currentIndex];
        const originalButton = clickedCard.querySelector(".product-video-info > a");

        if (originalButton) {
            const clonedButton = originalButton.cloneNode(true);
            buttonContainer.appendChild(clonedButton);
        }
    }
    
    function openPopup() {
        document.body.classList.add('overflow-hidden');
        popup.style.display = "flex";
        playVideo(currentIndex);
        buttonLinkChange()
    }

    function closePopup() {
        document.body.classList.remove('overflow-hidden');
        popup.style.display = "none";
        popupIframe.src = "";
    }

    function playVideo(index) {
        popupIframe.src = `${videoList[index]}?background=%23ffffff&autoplay=true&loop=true&mute=true&controls=false&tr=w-500`;
        const basePopupIframeSrc = popupIframe.src?.split("?")[0]
        popupIframe.src = `${basePopupIframeSrc}?background=%23ffffff&autoplay=true&loop=true&mute=true&controls=true&tr=w-500`;
        buttonLinkChange()
    }

    btnNext.addEventListener("click", () => {
        currentIndex = (currentIndex + 1) % videoList.length;
        playVideo(currentIndex);
    });

    btnPrev.addEventListener("click", () => {
        currentIndex = (currentIndex - 1 + videoList.length) % videoList.length;
        playVideo(currentIndex);
    });

    btnClose.addEventListener("click", closePopup);
        popup.addEventListener("click", (e) => {
        if (e.target === popup) closePopup();
        });
        document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") closePopup();
    });

});
